import React from 'react';
import { GRANULARITIES, DATE_PRESETS } from './constants';

export const GranularityToggles = ({ value, onChange }) => (
  <div className="mb-4 flex flex-wrap items-center gap-2">
    <span className="text-sm font-medium text-slate-600 mr-2">View by:</span>
    {GRANULARITIES.map((g) => (
      <button
        key={g.id}
        onClick={() => onChange(g.id)}
        className={`px-4 py-2 rounded-lg text-sm font-medium transition-all ${
          value === g.id
            ? 'bg-[#2E5C8A] text-white shadow-md'
            : 'bg-white text-slate-600 border border-slate-200 hover:border-[#2E5C8A] hover:text-[#2E5C8A]'
        }`}
        data-testid={`granularity-${g.id}`}
      >
        {g.label}
      </button>
    ))}
  </div>
);

export const DateRangePresets = ({ value, onChange, granularity, periodCount }) => (
  <div className="mb-6 flex flex-wrap items-center gap-2">
    <span className="text-sm font-medium text-slate-600 mr-2">Time Range:</span>
    {DATE_PRESETS.map((preset) => (
      <button
        key={preset.id}
        onClick={() => onChange(preset.id)}
        className={`px-3 py-1.5 rounded-full text-sm font-medium transition-all ${
          value === preset.id
            ? 'bg-[#4CAF93] text-white shadow-sm'
            : 'bg-slate-100 text-slate-600 hover:bg-slate-200'
        }`}
        data-testid={`preset-${preset.id}`}
      >
        {preset.label}
      </button>
    ))}
    <span className="text-xs text-slate-400 ml-2">
      ({periodCount} {granularity === 'daily' ? 'days' : granularity === 'weekly' ? 'weeks' : 'periods'})
    </span>
  </div>
);
